<template>
  <div
    class="drop-down-button flex-center"
    ref="buttonDropDown"
    :class="[
      hasBorderParent ? 'border-drop-down-btn' : '',
      disabled ? 'disabled-btn' : '',
      isBtnFooterHelpFul ? 'btn-footer-helpful' : '',
    ]"
  >
    <menu-wrapper
      class="widget-more-container widget-btn"
      :class="[type]"
      :disabled="disabled"
      :maxHeight="maxHeight"
    >
      <template #menu-button="{ toggleMenu }">
        <button
          class="btn flex-row primary-button"
          :class="[type, classCustom, hasBorder ? '' : 'btn-border-none']"
          :disabled="disabled"
          @click.prevent="toggleMenu"
        >
          <div :class="['icon24 icon left', leftIcon]" v-if="leftIcon">
            &nbsp;
          </div>
          <div class="text" :class="[{ 'pl-0': leftIcon }]" v-if="text">
            {{ text }}
          </div>
        </button>
        <div class="button-line"></div>

        <button
          @click.prevent="toggleMenu"
          class="widget-more"
          :class="[
            type,
            classCustom,
            hasBorder ? '' : 'btn-border-none',
            isBtnFooterHelpFul ? 'footer' : '',
          ]"
          :disabled="disabled"
        ></button>
      </template>
      <template #menu-content>
        <menu-item
          v-for="(item, index) in menuItems"
          :key="index"
          :seperatorBottom="item.seperatorBottom"
          :disabledItem="item.disabledItem"
          @menu-item-click="clickItem(item)"
          :class="item.class"
        >
          <v-menu placement="right" v-if="item.IsSubMenu" :offset-x="true">
            <div class="flex-between flex1">
              <div class="content">{{ item.text }}</div>
              <div :class="['icon24 icon right', item.icon]"></div>
            </div>
            <template #popper>
              <menu-item
                v-for="(itemSub, index) in item.subItem"
                @menu-item-click="clickItem(itemSub)"
                >{{ itemSub.text }}</menu-item
              >
            </template>
          </v-menu>
          <div v-else>
            {{ item.text }}
          </div>
        </menu-item>
      </template>
    </menu-wrapper>
  </div>
</template>
<script>
import { defineComponent, computed, ref } from 'vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';

export default defineComponent({
  name: 'msDropDownButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    //Text hiển thị
    text: {
      defualt: null,
      type: String,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: 'chevron-down-white',
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    // chiều cao tối đa cho menu để hiển thị scroll nếu menu quá dài
    maxHeight: {
      default: null,
      type: Number,
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: new Array(),
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, //25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    //border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    //border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
    // button tiện ích footer có hover màu xanh nước biển
    isBtnFooterHelpFul: {
      default: false,
      type: Boolean,
    },
    /**
     * Thêm class root để style menu-wrapper
     * tbngoc 19.07.2022
     */
    classRoot: {
      default: '',
      type: String,
    },
  },
  setup(props, { emit }) {
    const clickItem = (item) => {
      emit('menuClick', item);
    };

    const toggleMenu = ref(false);
    // end -----------------------------------------------------------------------

    return {
      clickItem,
      toggleMenu,
    };
  },
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';

:deep(.btn) {
  min-width: 60px;
}

.drop-down-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

:deep(.menu-button-container) {
  display: flex;
}
:deep(.flex) {
  display: flex;
}
:deep(.wrapper-utilities) {
  z-index: 1000 !important;
}
.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-bg;
    color: #14aa8a;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #fff;
}
.drop-down-button {
  &.border-drop-down-btn {
    border: 1px solid #afafaf;
    border-radius: 3px;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}
</style>
